export const UNICODE_GROUP_SEPARATOR = '\u{0029}';

export const trim = (str?: string | null): string => String(str).trim();

export const isEmptyStringOrNull = (value?: string | null): boolean =>
  value == null || value.trim() === '';

/** Capitalizes a string. By default, this function will force all but the first letter to lowercase
 * */
export const capitalize = (str: string, preserveCase: boolean = false): string => {
  const rest = preserveCase ? str : str.toLowerCase();
  return str.charAt(0).toUpperCase() + rest.slice(1);
};

const SPECIAL_PLURAL_CASES = {
  hero: 'heroes',
};

export function pluralize(count: number, word: string): string {
  if (Intl.PluralRules == null) {
    return word;
  }

  const pluralRules = new Intl.PluralRules('en-US');
  const pluralForm = pluralRules.select(count);

  switch (pluralForm) {
    case 'one':
      return word;
    case 'other':
      if (word.endsWith('y') && !'aeiou'.includes(word[word.length - 2].toLowerCase())) {
        return word.slice(0, -1) + 'ies';
      }
      if (word.endsWith('z')) {
        return word + 'zes';
      }
      if (word.endsWith('s') || word.endsWith('x') || word.endsWith('ch') || word.endsWith('sh')) {
        return word + 'es';
      }
      if (word in SPECIAL_PLURAL_CASES) {
        return SPECIAL_PLURAL_CASES[word as keyof typeof SPECIAL_PLURAL_CASES];
      }
      return `${word}s`;
    default:
      throw new Error(`Unexpected plural form: ${pluralForm}`);
  }
}

export function conjugateVerb(count: number, verb: string): string {
  if (Intl.PluralRules == null) {
    return verb;
  }

  const pr = new Intl.PluralRules();
  return pr.select(count) === 'one' ? verb + 's' : verb;
}

export function addNumberSuffix(num: number | string): string {
  const suffixes = new Map([
    ['one', 'st'],
    ['two', 'nd'],
    ['few', 'rd'],
    ['other', 'th'],
  ]);

  if (Intl.PluralRules == null) {
    return String(num);
  }

  const pr = new Intl.PluralRules('en', { type: 'ordinal' });
  const suffix = suffixes.get(pr.select(Number(num)));

  if (!suffix) {
    return String(num);
  }

  return `${num}${suffix}`;
}
